import { useCallback } from 'react';
import { useNodes, useReactFlow } from 'reactflow';
import useViewportSize from '~/components/util/useViewportSize';
import { DEFAULT_HEIGHT, DEFAULT_WIDTH } from '../../components/nodeTypes';

const LEFT_PADDING = 300;

/**
 * @returns a function that pans/focusses an action
 */

const usePanToActionId = (actionId: string | null) => {
  const renderedNodes = useNodes();
  const currentNode = renderedNodes.find(({ id }) => actionId === id);

  const [{ width, height }] = useViewportSize();
  const { fitBounds } = useReactFlow();

  const panTo = useCallback(() => {
    if (!currentNode) return;
    const { x, y } = currentNode.position;
    fitBounds(
      {
        x: x > 0 ? x - LEFT_PADDING - DEFAULT_WIDTH / 3 : -LEFT_PADDING,
        y: y - DEFAULT_HEIGHT / 2,
        width: width / 2 + LEFT_PADDING,
        height: height / 2,
      },
      { duration: 1000, padding: 0.6 },
    );
  }, [width, height, fitBounds, currentNode]);

  return panTo;
};

export default usePanToActionId;
